import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { ResponseModelInterfaceStatic } from "../response-model-interface";
import { Response } from "./computation/response";
import { Status } from "./computation/status";

@staticImplements<ResponseModelInterfaceStatic>()
export class ComputationResult
{
    public constructor(
        public queryId: string,
        public status: Status,
        public responses: Response[],
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): ComputationResult
    {
        const queryId = elem.firstChildByTag("queryId").value();
        const status = Status.makeFromXml(elem.firstChildByTag("queryStatus"));
        const responses: Response[] = [];

        elem.firstChildByTag("responses").forEachChildWithTag("response", (subElem) => {
            const statusCode = subElem.firstChildByTagOrNull("requestStatus")?.firstChildByTagOrNull("statusCode")?.value();

            // Don't try to decode errors, put a warning in the browser console instead
            if (statusCode !== "0") {
                const requestId = subElem.firstChildByTagOrNull("requestId")?.value() ?? "";
                const statusLit = subElem.firstChildByTagOrNull("requestStatus")?.firstChildByTagOrNull("statusCodeLit")?.value() ?? "";
                console.error(`Got error from API for computation request ${requestId} in query ${queryId} with message "${statusLit}", ignoring this result`);
                return;
            }

            responses.push(Response.makeFromXml(subElem));
        });

        return new this(queryId, status, responses);
    }

    public getResponseById(requestId: string): Response
    {
        const response = this.getResponseByIdOrNull(requestId);
        
        if (response === null) {
            throw new Error(`Cannot find response for request ${requestId} in query ${this.queryId}`);
        }

        return response;
    }

    public getResponseByIdOrNull(requestId: string): Response|null
    {
        for (const response of this.responses) {
            if (response.requestId === requestId) {
                return response;
            }
        }

        return null;
    }
}
